import React, { useContext } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Typography, Button, Empty, Tag, Divider, Tooltip } from "antd";
import { useLibrary } from  "PlatForms/OrgLMS/Hooks/MentorHooks/useLibrary";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography;
const Library = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const navigate = useNavigate();
  const { courses, loading } = useLibrary();
  const [expandedSkills, setExpandedSkills] = useState({});
  const toggleSkills = (courseId) => {
    setExpandedSkills(prev => ({
      ...prev,
      [courseId]: !prev[courseId]
    }));
  };
  return (
    <Card
      className="card-professional"
      loading={loading}
      title="Library-Courses"
    >
      {/* Courses List */}
      <Row gutter={[16, 16]} style={{ marginTop: 16, opacity: isBlocked ? 0.6 : 1, pointerEvents: isBlocked ? "noen" : "auto" }}>
        {courses.length > 0 ? (
          courses.map((course) => (
            <Col key={course.id} xs={24} sm={12} md={12}>
              <Card
                bordered={false}
                style={{
                  height: 300,
                  borderRadius: 12,
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  padding: "16px",
                  background: course.archived ? "rgb(224 235 235)" : "#ffffff",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 10, minHeight: 40 }}>
                  <Tooltip title={isBlocked ? "First complete your profile " : ""}>
                    <Button
                      type="primary"
                      size="small"
                      disabled={isBlocked}
                      onClick={() => !isBlocked && navigate(`/course-detail/${course.id}`)}
                    >
                      Content
                    </Button>
                  </Tooltip>
                </div>
                <p style={{ marginBottom: 8, wordBreak: "break-word", color: course.archived ? "#d46b08" : "#1890ff" }}>
                  <strong>{course.title}</strong>
                </p>
                <div style={{ maxHeight: 140, overflowY: "auto", paddingRight: 8 }}>
                  <Text style={{ display: "block", color: "#595959", fontSize: "13px", lineHeight: 1.4 }}>
                    {course.description || "N/A"}
                  </Text>
                  {/* Skills section */}
                  {course.courseSkills?.length > 0 ? (
                    <>
                      <Divider orientation="left" style={{ margin: '8px 0', fontSize: '12px' }}>
                        Skills
                        {course.courseSkills.length > 3 && (
                          <Tooltip title={isBlocked ? "First complete your profile " : ""}>
                            <Button
                              type="link"
                              size="small"
                              disabled={isBlocked}
                              onClick={() => isProfileComplete && toggleSkills(course.id)}
                              style={{ marginLeft: 8 }}
                            >
                              {expandedSkills[course.id] ? 'Show Less' : `+${course.courseSkills.length - 3} more`}
                            </Button>
                          </Tooltip>
                        )}
                      </Divider>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '8px' }}>
                        {(expandedSkills[course.id] ? course.courseSkills : course.courseSkills.slice(0, 3)).map((skill) => (
                          <Tag
                            key={skill.id}
                            color="#2d5772ff"
                            style={{ margin: 0, fontSize: '12px' }}
                          >
                            {skill.name}
                          </Tag>
                        ))}
                      </div>
                    </>
                  ) : (
                    <Text type="secondary">No skills data available</Text>
                  )}
                  <div style={{ marginTop: 8 }}>
                    <Text strong style={{ color: "#333", fontSize: "13px" }}>Created on:</Text>
                    <Text style={{ display: "block", color: "#595959", fontSize: "13px" }}>
                      {new Date(course.createdOn).toLocaleString()}
                    </Text>
                  </div>
                </div>
              </Card>
            </Col>
          ))
        ) : (
          <Col span={24} style={{ textAlign: "center", padding: "20px" }}>
            <Empty description="Not available" />
          </Col>
        )}
      </Row>
    </Card>
  );
};
export default Library;
